function isNullish(v) {
  return v == null;
}

export { isNullish };